import { createFileRoute } from "@tanstack/react-router";

/** `?album=final` — open the order's album on its "5. Ảnh hoàn thiện" folder (link from the Hậu kỳ screen). */
export type GalleryOrderSearch = { album?: "final" };

export const Route = createFileRoute("/_app/gallery/orders/$orderId/")({
  validateSearch: (search: Record<string, unknown>): GalleryOrderSearch =>
    search["album"] === "final" ? { album: "final" } : {},
});
